import { createAuthClient } from 'better-auth/react';

const API_URL = import.meta.env.VITE_API_URL || 'https://outpost9-api.outpost9.workers.dev';

export const authClient = createAuthClient({
  baseURL: API_URL,
  basePath: '/auth',
});
